export default "__VITE_ASSET__bBftT3lp__"